import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { RemolqueService } from '../../../services/RemolqueService';

export const TIPO_REMOLQUE_OPTIONS = [
  { value: 'CTR001', label: 'CTR001 - Caballete' },
  { value: 'CTR002', label: 'CTR002 - Caja' },
  { value: 'CTR003', label: 'CTR003 - Caja Abierta' },
  { value: 'CTR004', label: 'CTR004 - Caja Cerrada' },
  { value: 'CTR005', label: 'CTR005 - Caja De Recolección Con Cargador Frontal' },
  { value: 'CTR006', label: 'CTR006 - Caja Refrigerada' },
  { value: 'CTR007', label: 'CTR007 - Caja Seca' },
  { value: 'CTR008', label: 'CTR008 - Caja Transferencia' },
  { value: 'CTR009', label: 'CTR009 - Cama Baja o Cuello Ganso' },
  { value: 'CTR010', label: 'CTR010 - Chasis Portacontenedor' },
  { value: 'CTR011', label: 'CTR011 - Convencional De Chasis' },
  { value: 'CTR012', label: 'CTR012 - Equipo Especial' },
  { value: 'CTR013', label: 'CTR013 - Estacas' },
  { value: 'CTR014', label: 'CTR014 - Góndola Madrina' },
  { value: 'CTR015', label: 'CTR015 - Grúa Industrial' },
  { value: 'CTR016', label: 'CTR016 - Grúa' },
  { value: 'CTR017', label: 'CTR017 - Integral' },
  { value: 'CTR018', label: 'CTR018 - Jaula' },
  { value: 'CTR019', label: 'CTR019 - Media Redila' },
  { value: 'CTR020', label: 'CTR020 - Pallet o Celdillas' },
  { value: 'CTR021', label: 'CTR021 - Plataforma' },
  { value: 'CTR022', label: 'CTR022 - Plataforma Con Grúa' },
  { value: 'CTR023', label: 'CTR023 - Plataforma Encortinada' },
  { value: 'CTR024', label: 'CTR024 - Redilas' },
  { value: 'CTR025', label: 'CTR025 - Refrigerador' },
  { value: 'CTR026', label: 'CTR026 - Revolvedora' },
  { value: 'CTR027', label: 'CTR027 - Semicaja' },
  { value: 'CTR028', label: 'CTR028 - Tanque' },
  { value: 'CTR029', label: 'CTR029 - Tolva' },
  { value: 'CTR031', label: 'CTR031 - Volteo' },
  { value: 'CTR032', label: 'CTR032 - Volteo Desmontable' },
];

const RemolqueForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await RemolqueService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
    };
    return await RemolqueService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'Placa',
      label: 'Placa',
      type: 'text',
      col: 6,
      required: true,
      placeholder: 'Ej. 12-AA-3B',
      validators: [Validators.required('La placa es obligatoria')],
    },
    {
      name: 'SubTipoRem',
      label: 'Tipo de Remolque',
      type: 'autocomplete',
      col: 6,
      required: true,
      placeholder: 'Buscar o seleccionar tipo de remolque...',
      options: TIPO_REMOLQUE_OPTIONS,
      validators: [Validators.required('El tipo de remolque es obligatorio')],
    },
  ], []);

  return (
    <CatalogForm
      title="Remolque"
      subtitle="Administración de unidades de remolque y catálogo SAT de subtipos de remolque"
      fields={fields}
      initialValues={{
        Placa: '',
        SubTipoRem: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Remolques"
    />
  );
};

export default RemolqueForm;
